import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button, Empty,Card } from "antd";


import "./nusubscription.scss";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";
import NuJobsPlanTableSelectable from "../nujobsPlanTableSelectable";
import NuJobsPlanCards from "../nujobsPlansCards";
import NuJobsTable from "../nujobsTable";


const mySubscriptionTable = [
    "Sr. No.",
    "Type", 
    "Plan Name", 
    "Status",
    "Duration",
    "Start Date",
    "End Date"   
];
const historySubscriptionTable = [
    "Sr. No.",
    "Type", 
    "Plan Name",     
    "Status",
    "Duration",
    "Start Date",
    "End Date",
    "Plan Amount",
    "Discount",
    "Referral Discount",
    "Paid Amount",        
    "Payment Status",
    "Payment Date",
    "Payment Mode",
    "Reference Number"    
];
const myplanTable = [
    "Select",
    "Sr. No.",
    "Plan Name",  
    "Product",
    "No of Users",
    "No of Resumes",
    "No of Jb Posts",
    "Vendor Connect",    
];

export default function NUJobsSubscription() {
    const [currentView, setCurrentView] = useState("plans");
    const navigate = useNavigate();
    const { value } = useParams();
    const moment = require('moment');
    const { nuJobsGetSubscriptionPlans,subscriptionPlans, mySubscription,nuJobsGetMySubscriptions} = useNuJobDetailsStore();    

    useEffect(() => {
       const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
       nuJobsGetSubscriptionPlans(userData.nujoid,userData.nujuid );
       nuJobsGetMySubscriptions(userData.nujoid,userData.nujuid)
    }, []);
   

    const getSubType =(status)=>{
         return status  
    }
    const getReferralCode =(status)=>{
         return "NUJOBS_REF_676776" 
    }    
    const getReferralDiscount =(status)=>{
         return 0 
    }
    const getPlanID =(idx)=>{
            return mySubscription?.[0].subid
    }
    const getEndDate =(idx)=>{
            return mySubscription?.[0].enddate
    }
    const getStartDate =(idx)=>{
           return mySubscription?.[0].startdate
    }  

    const convertDateFromTStoDate = (ts) =>{
        if(ts !=""){
            var date = new Date(ts * 1000);
            return moment(date).format('YYYY.MM.DD');

        }else{
            return ""
        }
        
    }
    const mySubscriptionListData = mySubscription?.map((stats, idx) => {
        var stype = getSubType(stats?.status)
        return {
            id:idx+1,
            type:stype,
            planname: stats?.planname,
            substatus: stats?.status=="free"?"Active":stats?.status,
            duration: stats?.duration==0?"Unlimited":stats?.duration,
            startdate: convertDateFromTStoDate(stats?.startdate),
            enddate: stats?.enddate==stats?.startdate?"--":convertDateFromTStoDate(stats?.enddate)
        };
    });  

    const historySubscriptionListData = mySubscription?.map((stats, idx) => {
        var stype = getSubType(stats?.status)
        var sduration = stype=="TRIAL"?stats?.shistory?.[0].trialperiod :stats?.shistory?.[0].duration + " Months"
        return {
            id:idx+1,
            id:idx+1,
            type:stype,
            planname: stats?.planname,
            substatus: stats?.status=="free"?"Active":stats?.status,
            duration: stats?.duration==0?"Unlimited":stats?.duration,
            startdate: convertDateFromTStoDate(stats?.startdate),
            enddate: stats?.enddate==stats?.startdate?"--":convertDateFromTStoDate(stats?.enddate),
            planamount:stats?.paymentamount,
            discount:stats?.paymentamount,
            refdiscount:stats?.paymentamount,
            paidamount:stats?.paymentamount,
            paymentstatus: stats?.paymentstatus==""?"--":stats?.paymentstatus,
            paymentdate: stats?.paymentdate,
            paymentmode:stats?.paymentmode==""?"--":stats?.paymentmode,
            referencenumber: stats?.paymentmethod,
        };
    });   

    const getSubDisplayStatus =(status)=>{
        if(status === "free"){return "FREE"}
        if(status === "trial_none"){return "-"}
        if(status === "trial_inactive"){return "INACTIVE"}
        if(status === "trial_active"){return "ACTIVE"}
        if(status === "trial_expired"){return "EXPIRED"}   
        if(status === "trial_stop"){return "STOP"}
        if(status === "trial_activation_in_progress"){return "ACTIVATION IN PROGRESS"}    
        if(status === "subscription_none"){return "-"}
        if(status === "subscription_inactive"){return "INACTIVE"}
        if(status === "subscription_new_req"){return "NEW REQ "}
        if(status === "subscription_configured"){return "CONFIGURED"}
        if(status === "subscription_active"){return "ACTIVE"}
        if(status === "subscription_expired"){return "EXPIRED"}
        if(status === "subscription_stopped"){return "STOPPED"} 
        if(status === "subscription_aborted"){return "ABORTED"} 
        if(status === "subscription_activation_in_progress"){return "ACTIVATION IN PROGRESS"}  

    }

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    return (

        <div className="nusubscription-summary-wrapper">
            {currentView !== "profile" && (
                <>
                    <div className="section-header">
                        <h3 className="title">Subsciption Details</h3>
                    </div>
                    <div className="jd-summary-buttons-wrapper">
                        <Button
                            className={`jd-summary-btn ${
                                currentView === "plans" && "jd-summary-btn-active"
                            }`}
                            onClick={() => setCurrentView("plans")}
                        >
                            Plans
                        </Button>        
                        <Button
                            className={`jd-summary-btn ${
                                currentView === "mysubscription" && "jd-summary-btn-active"
                            }`}
                            onClick={() => setCurrentView("mysubscription")}
                        >
                            My Subscription
                        </Button>                                                                                                                          
                    </div>
                </>
            )}
            {mySubscription != null? (
                <div className="jd-summary-wrapper">
                    {
                    currentView === "plans" ? (
                           <NuJobsPlanCards
                                data={subscriptionPlans}                              
                          />                                                                                                                      
                    ): (
                        <div className="superadmin-subs-wrapper ">
                          <div className="superadmin-subs-cards-wrapper">
                            <Card title="Referral Discount" variant="borderless" style={{ backgroundColor: "#e6f2ff" }}>
                                {getReferralDiscount(mySubscription?.[0].status)}
                            </Card>                            
                            <Card title="Referral Code" variant="borderless" style={{ backgroundColor: "#e6f2ff" }}>
                                {getReferralCode(mySubscription?.[0].status)}
                            </Card>
                            <Card title="Plan Name" variant="borderless" style={{ backgroundColor: "#e6f2ff" }}>
                                {mySubscription?.[0].planname}
                            </Card>                            
                            <Card title="Subscription Status" variant="borderless" style={{ backgroundColor: "#e6f2ff" }}>
                                {getSubDisplayStatus(mySubscription?.[0].status)}
                            </Card>
                          </div>

                          <div className="superadmin-subs-heading" > Curent Subscription</div>
                          <div className="superadmin-subs-history"> 
                                <NuJobsTable
                                        titleList={mySubscriptionTable}
                                        data={mySubscriptionListData}
                                />
                          </div>
                          <div className="superadmin-subs-heading" style={{ marginTop: "60px" }} > Subscription History</div>
                          <div className="superadmin-subs-history"> 
                                <NuJobsTable
                                        titleList={historySubscriptionTable}
                                        data={historySubscriptionListData}
                                        columnWidth = {[50, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,100,100,100,100,100]}
                                />
                          </div>                          
                        </div>                                                                                             
                    )}
                    
                </div>
            ) : (
                <Empty style={{ margin: "60px" }} >
                    <h4>My Dash Board</h4>
                </Empty>
            )}         
        </div>
    );
}
